import React from 'react';
import { Box, IconButton, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Error from './Error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';

const useStyles = makeStyles((theme) => ({
   paper: {
      padding: theme.spacing(2, 4, 3),
      width: '40%',
      borderRadius: '7.5px',
   },
}));

const ErrorPopup = ({ onClick, errorStatus, errorMessage }) => {
   const classes = useStyles();
   return (
      <Paper className={classes.paper}>
         <Box display={'flex'} justifyContent={'flex-end'}>
            <IconButton size={'small'} onClick={onClick}>
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </Box>
         <Error errorStatus={errorStatus} errorMessage={errorMessage} />
      </Paper>
   );
};
export default ErrorPopup;
